<!-- In your template -->
<div #contentDiv class="max-w-lg mx-auto flex-col pt-20 text-theme-text">
  <div class="flex-1 bg-theme-surface-95 backdrop-blur-2xl rounded-t-3xl min-h-[calc(100vh-5rem)]">
    <div class="flex flex-row pt-6 px-4 pb-4 items-center">
      <div class="mr-3">
        <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()"></app-circle-button>
      </div>
      <div class="ml-2 font-bold text-3xl break-words w-[calc(100%-3rem)]">{{title}}</div>
    </div>
    <app-prebook-banner></app-prebook-banner>
    <div *ngIf="order != null && !hasItems()" class="px-8 mt-10 text-theme-text">
      <div>{{getString("Du har inte lagt till något i din beställning ännu. Välj mat och dryck från menyn.")}}</div>
    </div>

    <!-- Main content -->
    <div *ngIf="hasItems() && showMainContent" class="px-8 pt-4">

      <!-- Items -->
      <div *ngFor="let item of editableItems; let i = index; let last = last;" class="py-3">
        <div class="flex flex-row max-w-full">
          <div class="w-[calc(100%-7rem)]">
            <div class="text-base/5 font-bold break-words" (click)="displayItem(item)">{{getString(item.name)}}</div>
            <div *ngIf="!item.included" class="text-base/5 tabular-nums font-medium text-theme-text2">{{item.formatted_item_total}}</div>
            <div *ngFor="let line of packageDetailsByRid[item.rid]" class="ml-2 mt-0.5 text-sm/5 text-theme-text3 break-words">{{line}}</div>
            <div *ngIf="packageChangeableByRid[item.rid] && !item.included && !item.mandatory && !partLocked()"
                 class="ml-2 mt-1 text-sm text-theme-text3 underline cursor-pointer" (click)="changePackage(item)">{{getString('Ändra')}}</div>
            <div *ngIf="item.customized" class="ml-2 mt-1 text-sm italic text-theme-text3 break-words">{{item.customized}}</div>
            <div class="text-base/5 break-words text-theme-text2">{{translateItemComment(item.comment)}}</div>
          </div>
          <div class="flex-1 flex flex-row justify-end">
            <app-plus-minus-sm-button [amount]="item.count" (onChangeAmount)="onChangeAmount(item,$event)"
                                      [disabled]="item.included==true || item.mandatory==true || partLocked()" [disableAdd]="item.has_post_actions === true"></app-plus-minus-sm-button>
          </div>
        </div>

        <!-- Included children (e.g. drink that comes with a meal) -->
        <div *ngFor="let child of includedChildrenByRid[item.rid]"
             class="ml-4 pl-3 mt-1 border-l-2 border-theme-text3/30 flex flex-row items-center">
          <i class="fas fa-plus text-xs text-theme-text3 mr-2"></i>
          <div class="flex-1 text-sm/5 text-theme-text2 break-words">
            <span class="font-medium">{{child.count}} x {{getString(child.name)}}</span>
            <span *ngIf="child.included" class="ml-2 text-xs uppercase tracking-wide text-theme-text3">{{getString("Ingår")}}</span>
            <span *ngIf="!child.included" class="ml-2 tabular-nums">{{child.formatted_item_total}}</span>
          </div>
        </div>
      </div>

      <!-- Fixed items such as room-service fee -->
      <div *ngFor="let item of fixedItems; let i = index; let last = last;">
        <div class="py-3 flex flex-row">
          <div class="flex-1">
            <div class="text-base/5 font-bold break-words">{{item.count}} x {{item.name}}</div>
            <div class="text-base/4 break-words text-theme-text3">{{item.customized}}</div>
            <div class="text-base/4 break-words text-theme-text3">{{translateItemComment(item.comment)}}</div>
            <div *ngIf="!item.included" class="tabular-nums font-medium text-theme-text3">{{item.formatted}}</div>
          </div>
        </div>
      </div>

      <app-separator></app-separator>
      <!-- Total -->
      <ng-container *ngTemplateOutlet="totalSection"></ng-container>

      <!-- A shared prebooking: what the rest of the party has picked, for everyone to see -->
      @if (partyOthers().length) {
        <div class="font-bold text-sm text-theme-primary mt-8"><i class="fas fa-caret-right mr-1"></i>{{getString("Sällskapet")}}</div>
        @for (guest of partyOthers(); track $index) {
          <div class="py-3">
            <div class="text-base/5 font-bold break-words">
              {{guest.name}}
              @if (guest.is_booker) {
                <span class="ml-1 text-sm font-medium text-theme-text3">{{getString("har bokat")}}</span>
              }
              @if (guest.done) {
                <span class="ml-1 text-sm font-medium text-theme-text3"><i class="fas fa-check mr-1"></i>{{getString("har valt klart")}}</span>
              }
            </div>
            @for (item of guest.items; track $index) {
              <div class="text-base/5 break-words text-theme-text2">{{item.count}} x {{item.name}}</div>
              @if (item.customized) {
                <div class="ml-2 text-sm italic text-theme-text3 break-words">{{item.customized}}</div>
              }
            }
            @if (!guest.items.length) {
              <div class="text-base/5 text-theme-text3">{{getString("Inget valt än")}}</div>
            }
          </div>
        }
      }


      <!-- Ange webbkod -->
      <div *ngIf="isDTOpen() && hasItems() && (order?.user_cfg?.dt == null || order?.user_cfg?.dt==='table') && mustScan()" class="mt-8 rounded-2xl">
        <app-separator></app-separator>
        <div class="flex-col mt-8">
          <div class="mb-3 text-lg/6 font-bold text-start">
            {{getString("Innan du beställer behöver vi veta var du sitter")}}
          </div>
          <div class="mb-6 text-sm/5 font-bold text-theme-text3 text-start">
            {{getString("Ange din bordskod. Den består av 5 bokstäver och du hittar den på ditt bord.")}}
          </div>
          <app-action-button [icon]="'fa-qrcode'" [chevron]="false" [text]="getString('Ange bordskod')" (onClick)="openWebcodeDialog()"></app-action-button>
        </div>
      </div>

      <!-- Ange rumsnummer -->
      <div *ngIf="isDTOpen() && hasItems() && order?.user_cfg?.dt==='roomservice' && !order?.user_cfg?.roomnumber" class="mt-8 rounded-2xl">


        <div class="flex-col">
          <div class="mb-3 text-lg/6 font-bold text-center">
            {{getString("Till vilket rum vill du ha beställningen?")}}
          </div>
          <div class="mb-2 text-sm/5 font-bold text-theme-text3 text-center">
            {{getString("Ange ditt rumsnummer så kommer vi dit med beställningen ")}}
          </div>
          <app-action-button [icon]="'fa-door-closed'" [chevron]="false" [text]="getString('Ange rumsnummer')" (onClick)="openRoomCodeDialog()"></app-action-button>
        </div>

      </div>

      <!-- Discount -->
      <div *ngIf="showOrderPayTip">
        <ng-container *ngTemplateOutlet="discountSection"></ng-container>
        <ng-container *ngTemplateOutlet="loyaltySection"></ng-container>
      </div>

      <!-- Inline recommendations -->
      <div *ngIf="isDTOpen() && inlineRecommendations && !mustScan() && !partLocked()" class="">
        <app-separator></app-separator>
        <div class="mt-8">
          <div>
            <div class="text-2xl font-medium">{{getString("Passar bra till")}}</div>
          </div>
        </div>
        <div>
          <div *ngFor="let item of inlineRecommendations; let lastit = last;" class="mt-3">
            <label class="flex items-start gap-3 w-full py-1 cursor-pointer">
              <div class="pt-1">
                <app-box-for-checkbox [ngModel]="selectedItems[item.id]"></app-box-for-checkbox>
              </div>
              <input type="checkbox"
                     [(ngModel)]="selectedItems[item.id]"
                     (change)="selectedChange(item)"
                     class="hidden">

              <app-push-item-content
                class="flex-1"
                [item]="item"
                [selectedItems]="selectedItems"
                [attrValues]="attrValues"
                [picked]="picked"
                (changePicks)="openPicks($event)">
              </app-push-item-content>

            </label>

          </div>
        </div>
      </div>

      <!-- Fulfillment mode -->
      <div *ngIf="payableOrOrderable() && order?.user_cfg?.collect?.fulfillment" class="bg-theme-surface2-50 rounded-xl p-4 mt-8">
        <div class="font-bold text-sm text-theme-primary">
          <i class="fas fa-caret-right mr-1"></i>{{getString("Äta här eller ta med?")}}
        </div>
        <div class="flex flex-col gap-2 mt-3 pl-4">
          <app-radio-label name="fulfillmentMode" [radioValue]="'inhouse'" [(ngModel)]="fulfillmentMode" (ngModelChange)="changeFulfillmentMode('inhouse')">
            <div class="text-base text-theme-primary">{{getString("Äta här")}}</div>
          </app-radio-label>
          <app-radio-label name="fulfillmentMode" [radioValue]="'takeaway'" [(ngModel)]="fulfillmentMode" (ngModelChange)="changeFulfillmentMode('takeaway')">
            <div class="text-base text-theme-primary">{{getString("Ta med")}}</div>
          </app-radio-label>
        </div>
      </div>

      <!-- Takeaway (hidden in prebook mode: the banner is the context, time is fixed) -->
      <div *ngIf="payableOrOrderable() && order?.user_cfg?.dt==='takeaway' && !isPrebookMode()" class="bg-theme-surface2-50 rounded-xl p-4 mt-8">
        <div class="font-bold text-sm text-theme-primary"><i class="fas fa-caret-right mr-1"></i>{{order?.user_cfg?.delivery_model === 'delivery' ? getString("Leverans"):getString("Upphämtning")}}</div>
        <div *ngIf="whenReadable" class="pl-3 text-theme-primary mt-1">{{whenReadable}}</div>

        <!-- Basic legacy takeaway without booking, guest can select asap or a time later this day -->
        <div *ngIf="order?.user_cfg?.collect?.takeaway_time">
          <div class="flex flex-col gap-2 mt-3 pl-4">
            <app-radio-label name="pickupTime" [radioValue]="'now'" [(ngModel)]="pickupTime" (ngModelChange)="timeClassChanged('now')">
              <div class="text-base text-theme-primary">Hämtas om {{order?.user_cfg?.takeaway?.cooking_time}} min</div>
            </app-radio-label>

            <app-radio-label name="pickupTime" [radioValue]="'later'" [(ngModel)]="pickupTime" (ngModelChange)="timeClassChanged('later')">
              <div class="text-base text-theme-primary">
                <ng-container *ngIf="!order?.pickup_time">Välj tid</ng-container>
                <ng-container *ngIf="order?.pickup_time">
                  <span class="mr-2">Hämtas {{order?.pickup_time}}</span>
                  <app-link-button [text]="getString('(välj annan tid)')" (onClick)="timeClassChanged('later')"></app-link-button>
                </ng-container>
              </div>
            </app-radio-label>
          </div>

        </div>

        <!-- Select a slot (booking or slotting) -->
        <div class="mt-4" *ngIf="order?.user_cfg?.collect?.slot_time">
          <app-border-icon-button [text]="getTakeawayButtonText()" (onClick)="selectSlotTime()" icon="fa-clock"></app-border-icon-button>
        </div>

        <div *ngIf="order?.user_cfg?.collect?.pickup_locations" class="mt-6">
          <div class="font-bold text-sm text-theme-primary"><i class="fas fa-caret-right mr-1"></i>{{order?.user_cfg?.delivery_model === 'delivery' ? getString("Leveransplats"):getString("Upphämtningsplats")}}</div>
          <div class="pl-4 mt-3">
            <div class="flex flex-col gap-1">
              <app-radio-label *ngFor="let pl of order!.user_cfg!.collect!.pickup_locations!"
                [(ngModel)]="pickupLocation"
                [radioValue]="pl"
                (ngModelChange)="changePickupLocation(pl)">
                <div class="text-base text-theme-primary">
                  {{order?.user_cfg?.delivery_model === 'delivery' ? getString("Levereras") : getString("Hämtas")}} {{pl}}
                </div>
              </app-radio-label>
            </div>
          </div>
        </div>
      </div>

      <!-- Collect info section -->
      <div *ngIf="payableOrOrderable() && (customCollects?.length??0)>0" class="bg-theme-surface2-50 rounded-xl p-4 mt-6">
        <div class="font-bold text-sm text-theme-primary"><i class="fas fa-caret-right mr-1"></i>{{getString(isPrebookMode() ? "Uppgifter" : "Kontaktinformation")}}</div>

        <div class="mt-4">
          <div *ngFor="let collect of customCollects" class="mt-2 flex-col">
            <div class="block font-medium mb-1 text-theme-primary">
              {{collect.title}}
            </div>
            <div *ngIf="collect.description" class="text-sm text-theme-primary-50 mb-1">
              {{collect.description}}
            </div>
            <input #inputField
              [id]="collect.id"
              [type]="getInputType(collect.inputType)"
              [formControl]="collect.formControl"
              [placeholder]="collect.placeholder || ''"
              maxlength="50"
              (keydown.enter)="inputField.blur()"
              (change)="customChanged(collect)"
              class="text-input"
            >
          </div>
        </div>
      </div>

    <!-- End of Main content -->
    </div>

    <!-- End of second page content header -->
    <div *ngIf="showOrderPayTip && isDualPage" class="px-8">
      <ng-container *ngTemplateOutlet="totalSection"></ng-container>
      <ng-container *ngTemplateOutlet="discountSection"></ng-container>
      <ng-container *ngTemplateOutlet="loyaltySection"></ng-container>
    </div>

    <!-- Inline donations -->
    <!-- TODO: Show inlinedonations when appearance is decided -->
    <!-- <div *ngIf="inlineDonations && inlineDonations.length > 0 &&
                isDTOpen() && hasItems() &&
                !order?.user_cfg?.payment?.open_order &&
                !mustScan() &&
                showOrderPayTip &&
                (order?.user_cfg?.dt !== 'roomservice' || (order?.user_cfg?.dt === 'roomservice' && order?.user_cfg?.roomnumber))"
                class="mt-6 px-8"
                >
      <app-inline-donations
        [inlineDonations]="inlineDonations"
        (selectedChange)="selectedChange($event)"
        [attrValues]="attrValues"
        [(selectedItems)]="selectedItems">
      </app-inline-donations>
    </div> -->

    <!-- TIP SELECTION -->
    <div *ngIf="payableOrOrderable() && !order?.user_cfg?.payment?.open_order && showOrderPayTip && !isFree() && showTip" class="px-8">
      <app-separator></app-separator>

      <app-tip-selection
        [amount]="order?.amount!"
        [config]="tipConfig"
        [selectedTip]="tipButtonId"
        (onTipChange)="handleTipChange($event)">
      </app-tip-selection>

    </div>

    <div class="mt-12 pb-12">
      <div *ngIf="payableOrOrderable() && showOrderPayTip" class="px-4">
        <div *ngIf="order?.user_cfg?.payment?.open_order">
          @if (isParticipant()) {
            <!-- A participant of a shared prebooking says they're done; the booker sends the party's order. Once done,
                 a receipt-like confirmation, and changing their mind is a quiet link, not a call to action -->
            @if (myPartDone()) {
              <div class="rounded-2xl bg-theme-surface2-50 p-6 text-center">
                <i class="fas fa-circle-check text-3xl text-theme-primary"></i>
                <div class="mt-2 text-lg font-bold">{{getString('Tack, du har valt klart!')}}</div>
                <div class="mt-1 text-sm text-theme-text2">{{participantInfoText()}}</div>
                <div class="mt-4 flex justify-center">
                  <app-link-button [text]="getString('Jag vill ändra något')" [disabled]="isWorking" (onClick)="reopenPart()"></app-link-button>
                </div>
              </div>
            } @else {
              <div class="mb-4 px-4 text-center text-sm text-theme-text2">{{participantInfoText()}}</div>
              <app-action-button [text]="getString('Jag har valt klart')" [chevron]="false" (onClick)="markPartDone()" [spinner]="isWorking"></app-action-button>
            }
          } @else {
            <!-- Confirming locks the booking, so the consequence and the deadline are spelled out above the button -->
            @if (isOpenPrebook()) {
              <div class="mb-4 px-4 text-center text-sm text-theme-text2">
                @if (partyStatusText()) {
                  <div class="mb-2 font-bold text-theme-text">{{partyStatusText()}}</div>
                }
                {{confirmInfoText()}}
              </div>
            }
            <app-action-button [text]="getString(isPrebookMode() ? 'Konfirmera bokning' : 'Skicka beställning')" [itemCount]="isPrebookMode() ? 0 : itemCount" (onClick)="send()" [spinner]="isWorking"></app-action-button>
          }
        </div>
        <div *ngIf="!order!.user_cfg!.payment!.open_order && isFree()">
          <app-action-button [text]="getString('Skicka beställning')" [itemCount]="isPrebookMode() ? 0 : itemCount" (onClick)="pay('free')" [spinner]="isWorking"></app-action-button>
        </div>
        <div *ngIf="!order!.user_cfg!.payment!.open_order && !isFree()">
          <app-payment-selector
            [appState]="appState!"
            (onSelect)="pay($event)"
            (onDirectPaymentComplete)="handleDirectPaymentComplete($event)"
            (onDirectPaymentFailed)="handleDirectPaymentFailed($event)"
            [disabled]="tipAmount==null"
            [totalSek]="order!.amount + (tipAmount ?? 0)"
            [tipParam]="'v' + (tipAmount ?? 0)"
            [payableRefs]="payableRefsForDirect"></app-payment-selector>
        </div>
        <!-- Terms Link -->
        <div *ngIf="!isFree()" class="mt-6 mb-8 text-center">
          <app-link-button [text]="getString('köpvillkor')" (onClick)="terms()" [font]="'font-medium'" [color]="'text-theme-text3'"></app-link-button>
        </div>
      </div>

      <div *ngIf="payableOrOrderable() && !showOrderPayTip" class="px-8">
        <app-action-button text="{{primaryPageActionText()}}" (onClick)="nextPage()" [itemCount]="0" [disabled]="false" [spinner]="isWorking"></app-action-button>
      </div>

      <div *ngIf="!venueOpen" class="flex justify-center w-full text-theme-text2 text-lg font-medium px-8">
        <i class="far fa-cart-circle-xmark mr-1"></i>
        {{getString("Stängt för beställning")}}
      </div>

      <div *ngIf="showLogin" class="mx-8">
        <div class="font-bold text-lg/6 mb-4 text-center">{{getString("Innan du beställer behöver vi veta vem du är")}}</div>
        <app-action-button [icon]="'fa-user-circle'"  [chevron]=false [text]="getString('Verifiera dig')" (onClick)="verify()"></app-action-button>
      </div>

    </div>

  </div>

  <!-- Spinner and backdrop  -->
  <div *ngIf="showSpinner" class="fixed top-0 bottom-0 left-0 right-0 bg-theme-surface-80 p-4 pb-safe z-10 flex items-center justify-center">
    <app-loading-spinner size="xl"></app-loading-spinner>
  </div>

  <!-- Div used for form-posting to Bambora for require3D -->
  <div id="formPostDivLS"></div>
</div>

<!-- Discount code add -->
<ng-template #discountSection>
  <div *ngIf="payableOrOrderable() && show_discount && !isKiosk && !order!.user_cfg!.payment!.open_order" class="flex flex-col my-4">
    <app-separator></app-separator>
    <div class="flex flex-row items-center mt-4">
      <div class="flex-1 text-lg text-theme-text2 font-bold">{{getString("Rabatt")}}</div>
      <app-light-icon-button *ngIf="!order?.discount" icon="fa-circle-plus" (onClick)="showDiscountDialog()" [text]="getString('Lägg till')"></app-light-icon-button>
      <div *ngIf="order?.discount" class="text-lg tabular-nums font-medium">-{{order?.discount_formatted}}</div>
    </div>
    <div class="flex justify-end">
      <div *ngIf="order?.discount" class="text-sm text-theme-text3 cursor-pointer underline" (click)="showDiscountDialog()">{{getString('Ändra')}}</div>
    </div>
  </div>
</ng-template>

<!-- Loyalty  -->
<ng-template #loyaltySection>
  <app-loyalty-info
    *ngIf="payableOrOrderable() && loyaltyInfo && !isKiosk && !order!.user_cfg!.payment!.open_order"
    [loyaltyInfo]="loyaltyInfo"
    [discountFormatted]="order?.discount_formatted"
    (activateDiscountCode)="activateDiscount($event)"
    (activateReward)="activateReward($event)">
  </app-loyalty-info>
</ng-template>


<ng-template #totalSection>
  <div class="flex flex-row mt-4">
    <div class="flex-1 text-lg text-theme-text2 font-bold">{{getString(partyOthers().length ? "Totalt för din beställning" : "Totalt")}}</div>
    <div class="text-lg tabular-nums font-bold">{{order?.total}}</div>
  </div>
</ng-template>
